
import React, { useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { Panna, workerMaster } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import { useDispatch } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { createCategoryInsert } from '../../Store/PHPSlice/WorkerM/Category';


const CategoryEntry = () => {
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        categoryNm: '',
        userId: '1'
    });
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleInputChange = (e) => {
        const { name, value } = e.target;
            setFormData({
                ...formData,
                [name]: value.toUpperCase()
            });

    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        // Validate department name
        // console.log(formData);
        // if (!formData.pana_size.trim()) {
        //     setErrors({ pana_size: 'Panna Size is required' });
        //     return;
        // }
        dispatch(createCategoryInsert(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                toast.success("Category Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };


    return (
        <>
            <Titlebar data={workerMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Category Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Category', name: 'categoryNm' , place:'Enter Name'},
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            placeholder={field.place}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default CategoryEntry;
